import { EWidget } from 'scw-digital-boards-widgets';
import { TWidgetSavePayload } from '../../../pages/dashboard-content/dashboard-content.interface';

export class ItemAttachmentThumbnail {
  constructor(
    public id: number | null,
    public originalFileName: string,
    public filePath: string,
    public mimeType: string,
  ) {}
}

export class MemoryStoredWidgetAttachmentFile {
  constructor(
    public id: number | null,
    public originalFileName: string,
    public url: string,
    public file: File,
  ) {}
}

export interface IWidgetsHavingAttachments {
  index: number;
  widget: TWidgetSavePayload<EWidget.imageViewer>;
}
